export default __webpack_public_path__ + "static/media/bc_logo.fa0ee463.svg";